import React, { useState } from 'react';
import { useCart } from '../context/CartContext';

const ShippingAddress = () => {
  const { shippingAddress, dispatch } = useCart();
  const [street, setStreet] = useState(shippingAddress.street || '');
  const [city, setCity] = useState(shippingAddress.city || '');
  const [postalCode, setPostalCode] = useState(shippingAddress.postalCode || '');
  const [country, setCountry] = useState(shippingAddress.country || '');

  const handleAddressChange = (event) => {
    const { name, value } = event.target;
    dispatch({ 
      type: 'SET_SHIPPING_ADDRESS', 
      payload: { 
        ...shippingAddress, 
        [name]: value 
      } 
    });
    
    switch (name) {
      case 'street':
        setStreet(value);
        break;
      case 'city':
        setCity(value);
        break;
      case 'postalCode':
        setPostalCode(value);
        break;
      case 'country':
        setCountry(value);
        break;
      default:
        break;
    }
  };

  return (
    <div className="bg-white border border-slate-200 p-6 rounded-xl shadow-sm">
      <h3 className="text-lg font-bold text-slate-800 mb-4 border-b border-slate-100 pb-2">Adresse de livraison</h3>
      <div className="space-y-4">
        <div>
          <label htmlFor="street" className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">
            Rue <span className="text-rose-500">*</span>
          </label>
          <input 
            type="text" 
            id="street" 
            name="street" 
            value={street} 
            onChange={handleAddressChange} 
            placeholder="Ex: 12 Rue de la Paix"
            required
            className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 placeholder-slate-400 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all" 
          />
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="postalCode" className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">
              Code Postal <span className="text-rose-500">*</span>
            </label>
            <input 
              type="text" 
              id="postalCode" 
              name="postalCode" 
              value={postalCode} 
              onChange={handleAddressChange} 
              placeholder="Ex: 75001"
              required
              className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 placeholder-slate-400 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all" 
            />
          </div>
          <div>
            <label htmlFor="city" className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">
              Ville <span className="text-rose-500">*</span>
            </label>
            <input 
              type="text" 
              id="city" 
              name="city" 
              value={city} 
              onChange={handleAddressChange} 
              placeholder="Ex: Paris"
              required
              className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 placeholder-slate-400 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all" 
            />
          </div>
        </div>

        <div>
          <label htmlFor="country" className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">
            Pays <span className="text-rose-500">*</span>
          </label>
          <input 
            type="text" 
            id="country" 
            name="country" 
            value={country} 
            onChange={handleAddressChange} 
            placeholder="Ex: France"
            required
            className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 placeholder-slate-400 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all" 
          />
        </div>
      </div>
    </div>
  );
};

export default ShippingAddress;